import { useCurrentSite } from '@hotjar/site';
import { useMemo } from 'react';
import { useSurveyFilters } from '../../../../hooks/useSurveyFilters';
import { useQuestionResultsQuery } from '../../../../domain/Surveys/Results/useQuestionResultsQuery';
import { filtersToSearchClauses } from '../../../../domain/Surveys/Responses/Filters/clauses';
import type { QuestionResults } from '../../../../domain/Surveys/Results/AggregatedResult';

export const useQuestionResults = (surveyId: number | undefined): QuestionResults | undefined => {
  const { data: site } = useCurrentSite();

  const { localFilters, globalFilters } = useSurveyFilters();

  const clauses = useMemo(
    () => filtersToSearchClauses(localFilters, globalFilters),
    [localFilters, globalFilters],
  );
  const { data: questionResult } = useQuestionResultsQuery(site?.id, surveyId, clauses);

  return questionResult;
};
